import img_DN from "./Images/img_DN.jpg";
import img_RO from "./Images/img_RO.jpeg";
import img_DJ from "./Images/img_DJ.jpg";
import img_NF from "./Images/img_NF.jpg";
import img_JR from "./Images/img_JR.jpg";
import img_AI from "./Images/img_AI.jpg";
import img_LV from "./Images/img_LV.jpg";
import img_MC from "./Images/Img_MC.jpeg";
import flag_arg from "./Images/flag_arg.png";
import flag_col from "./Images/flag_col.png";
import flag_mex from "./Images/flag_mex.png";

export const integrantes = [
  {
    name: "Debora Navarro",
    img: img_DN,
    countryImage: flag_arg,
  },
  {
    name: "Amilcar Ibarra",
    img: img_AI,
    countryImage: flag_col,
  },
  {
    name: "Javier Rivera",
    img: img_JR,
    countryImage: flag_mex,
  },
  {
    name: "Nicolas Navarrete",
    img: img_NF,
    countryImage: flag_arg,
  },
  {
    name: "Daniel Junghans",
    img: img_DJ,
    countryImage: flag_mex,
  },
  {
    name: "Mariano Caroso",
    img: img_MC,
    countryImage: flag_arg,
  },
  {
    name: "Lorenzo Velez",
    img: img_LV,
    countryImage: flag_arg,
  },
  {
    name: "Roberto Ochoa",
    img: img_RO,
    countryImage: flag_arg,
  },
];
